import Routes from '../../services/routes'
import * as types from "../mutationTypes";

const emptyRoute = {
    name: '',
    color: '',
    jobTasks: []
}

function setTagStrings(route){
    route.jobTasks.forEach(jt => {
        if (jt.jobTaskTags.length === 0){
            jt.tagsList = []
        } else {
            jt.tagsList = jt.jobTaskTags.map(jtt => jtt.tag.name)
        }
    })
}

let state = {
    routes: null,
    archivedRoutes: null,
    selectedRoute: emptyRoute,
    routeNumbers: null,
    routeLocations: null,
    createdRoute: null,
    activeRange: [],
    archivedRange: [],
    activeCount: 0,
    archivedCount: 0,
    colorPickerColors: [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#0000FF', '#0000AA', '#000055']
        ],
    selectedRouteIncompleteTasks: [],
    headers: [
        { text: 'Name', value: 'name' },
        { text: 'Duration', value: 'duration' },
        { text: '# of Tasks', value: 'jobTasks.length' },
        { text: 'Crew Members', value: 'crew'},
        { text: 'Completed', value: 'complete'},
        { text: 'Actions', value: 'action', sortable: false }
    ],
    workerHeaders: [
        { text: 'Name', value: 'name' },
        { text: '# of Tasks', value: 'jobTasks.length' },
        { text: 'Crew Members', value: 'crew'},
        { text: 'Completed', value: 'complete'},
        { text: 'Actions', value: 'action', sortable: false }
    ],
    detailsHeaders: [
        { text: 'Order', value: 'iconId' },
        { text: 'Address', value: 'address' },
        { text: 'Status', value: 'status' },
        { text: 'Tags', value: 'tagString' },
        { text: 'Actions', value: 'action', sortable: false}
    ],
    error: null
}
let getters = {
    routes (state) {
        return state.routes
    },
    activeRange (state) {
        return state.activeRange
    },
    selectedRoute (state) {
        return state.selectedRoute
    },
    selectedRouteIncompleteTasks (state) {
        return state.selectedRouteIncompleteTasks
    },
    archivedRoutes (state) {
      return state.archivedRoutes
    },
    archivedRange (state) {
        return state.archivedRange
    },
    activeCount (state) {
        return state.activeCount
    },
    archivedCount (state) {
        return state.archivedCount
    },
    colorPickerColors (state) {
        return state.colorPickerColors
    },
    error (state) {
        return state.error
    },
    routeNumbers (state) {
        return state.routeNumbers.map(rn => {
            return { text: rn.name, value: rn.id }
        })
    },
    routeLocations (state) {
        return state.routeLocations
    },
    headers (state) {
        return state.headers
    },
    workerHeaders (state) {
        return state.workerHeaders
    },
    detailsHeaders (state) {
        return state.detailsHeaders
    }
}
const mutations = {
    [types.REQUEST_GET_ALL_ROUTES_SUCCESS] (state, routes) {
        state.routes = routes
        state.error = null
    },
    [types.REQUEST_GET_ALL_ROUTES_ERROR] (state, message) {
        state.error = message
        state.routes = null
    },

    [types.REQUEST_GET_ACTIVE_ROUTE_RANGE_SUCCESS] (state, routes) {
        state.activeRange = routes
        state.error = null
    },
    [types.REQUEST_GET_ACTIVE_ROUTE_RANGE_ERROR] (state, message) {
        state.error = message
        state.activeRange = null
    },
    [types.REQUEST_GET_ARCHIVED_ROUTE_RANGE_SUCCESS] (state, routes) {
        state.archivedRange = routes
        state.error = null
    },
    [types.REQUEST_GET_ARCHIVED_ROUTE_RANGE_ERROR] (state, message) {
        state.error = message
        state.archivedRange = null
    },
    [types.REQUEST_GET_ROUTE_BY_ID_ERROR] (state, message) {
        state.error = message
        state.selectedRoute = emptyRoute
    },
    [types.REQUEST_UPDATE_ROUTE_SUCCESS] (state, route) {
        state.routes = route
        state.error = null
    },
    [types.REQUEST_UPDATE_ROUTE_ERROR] (state, message) {
        state.error = message
        state.routes = null
    },
    [types.REQUEST_DELETE_ROUTE_SUCCESS] (state, route) {
        state.route = route
        state.error = null
    },
    [types.REQUEST_DELETE_ROUTE_ERROR] (state, message) {
        state.error = message
        state.route = null
    },
    [types.REQUEST_CREATE_ROUTE_SUCCESS] (state, route) {
        state.createdRroute = route
        state.error = null
    },
    [types.REQUEST_CREATE_ROUTE_ERROR] (state, message) {
        state.error = message
        state.createdRoute = null
    },
    [types.REQUEST_ARCHIVE_ROUTE_SUCCESS] (state, route) {
        state.route = route
        state.error = null
    },
    [types.REQUEST_ARCHIVE_ROUTE_ERROR] (state, message) {
        state.error = message
        state.route = null
    },
    [types.REQUEST_COMPLETE_ROUTE_SUCCESS] (state, route) {
        state.route = route
        state.error = null
    },
    [types.REQUEST_COMPLETE_ROUTE_ERROR] (state, message) {
        state.error = message
        state.route = null
    },
    [types.REQUEST_RESTORE_ROUTE_SUCCESS] (state, route) {
        state.route = route
        state.error = null
    },
    [types.REQUEST_RESTORE_ROUTE_ERROR] (state, message) {
        state.error = message
        state.route = null
    },
    [types.REQUEST_GET_ACTIVE_ROUTE_COUNT] (state, count) {
        state.activeCount = count
    },
    [types.REQUEST_GET_ARCHIVED_ROUTE_COUNT] (state, count) {
        state.archivedCount = count
    },
    [types.REQUEST_GET_ROUTE_NUMBERS_SUCCESS] (state, routeNumbers) {
        state.routeNumbers = routeNumbers
        state.error = null
    },
    [types.REQUEST_GET_ROUTE_NUMBERS_ERROR] (state, message) {
        state.routeNumbers = null
        state.error = message
    },
    [types.REQUEST_GET_ROUTE_LOCATIONS_SUCCESS] (state, routeLocations) {
        state.routeLocations = routeLocations
        state.error = null
    },
    [types.REQUEST_GET_ROUTE_LOCATIONS_ERROR] (state, message) {
        state.routeLocations = null
        state.error = message
    },
    [types.REQUEST_SET_SELECTED_ROUTE_SUCCESS] (state, route) {
        state.selectedRoute = route
        state.error = null
    },
    [types.REQUEST_SET_SELECTED_ROUTE_ERROR] (state, message) {
        state.selectedRoute = emptyRoute
        state.error = message
    },
    [types.CLEAR_SELECTED] (state) {
        state.selectedRoute = emptyRoute
    },
    [types.CLEAR_LOCATIONS] (state) {
        state.routeLocations = null
    },
    [types.REQUEST_SET_SELECTED_ROUTE_INCOMPLETE_TASKS] (state, tasks) {
        state.selectedRouteIncompleteTasks = tasks
    },
    [types.REQUEST_GET_ALL_ARCHIVED_ROUTES_SUCCESS] (state, routes) {
        state.archivedRoutes = routes
        state.error = null
    },
    [types.REQUEST_GET_ALL_ARCHIVED_ROUTES_ERROR] (state, message) {
        state.archivedRoutes = null
        state.error = message
    },
    [types.REQUEST_ADD_USERS_TO_TASK_SUCCESS] (state, userRoutes) {
        state.userRoutes = userRoutes
        state.error = null
    },
    [types.REQUEST_ADD_USERS_TO_TASK_ERROR] (state, message) {
        state.userRoutes = null
        state.error = message
    },
    [types.REQUEST_REMOVE_USERS_TO_TASK_SUCCESS] (state, userRoutes) {
        state.userRoutes = userRoutes
        state.error = null
    },
    [types.REQUEST_REMOVE_USERS_TO_TASK_ERROR] (state, message) {
        state.userRoutes = null
        state.error = message
    },
    [types.REQUEST_ADD_TASKS_TO_ROUTE_ERROR] (state, message) {
        state.error = message
    },
    [types.REQUEST_ADD_TASKS_TO_ROUTE_SUCCESS] (state) {
        state.error = null
    },
    [types.REQUEST_CLEAR_TASKS_FROM_ROUTE_ERROR] (state, message) {
        state.error = message
    },
    [types.REQUEST_CLEAR_TASKS_FROM_ROUTE_SUCCESS] (state) {
        state.error = null
    },
    [types.CLEAR_ROUTES] (state) {
        state.routes = null
    }
}
const actions = {
    async clearLocations ({ commit }) {
        commit(types.CLEAR_LOCATIONS)
    },
    async getRouteAndLocations({ commit }) {
      try {
          let res = await Routes.getRouteLocations()
          if (res) {
              commit(types.REQUEST_GET_ROUTE_LOCATIONS_SUCCESS, res.data)
              commit(types.CLEAR_SELECTED)
          }
      } catch (error) {
          commit(types.REQUEST_GET_ROUTE_LOCATIONS_ERROR, error.message)
      }
    },

    async getIsolatedRoute({ commit, dispatch }, id) {
    try {
        let res = await Routes.getIsolatedRouteLocations(id)
        dispatch('clearLocations')
        if (res) {
            commit(types.REQUEST_GET_ROUTE_LOCATIONS_SUCCESS, res.data)
            dispatch('getById', id)
        }
    } catch (error) {
            commit(types.REQUEST_GET_ROUTE_LOCATIONS_ERROR, error.message)
        }
    },

    async getRouteNumbers({ commit }) {
      try {
          let res = await Routes.getTaskRouteNumbers()
          if (res) {
              commit(types.REQUEST_GET_ROUTE_NUMBERS_SUCCESS, res.data)
          }
      } catch (e) {
          commit(types.REQUEST_GET_ROUTE_NUMBERS_ERROR, e.message)
      }
    },

    async getAll ({ commit }) {
        try {
            let res = await Routes.get()
            if (res) {
                commit(types.CLEAR_ROUTES)
                commit(types.REQUEST_GET_ALL_ROUTES_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_ALL_ROUTES_ERROR, error.message)
        }
    },
    async getActiveRange ({ commit }, rangeRequest) {
        const keywords = rangeRequest.keywords
        const limit = rangeRequest.limit
        const offset = rangeRequest.offset
        try {
            let res = await Routes.getActiveRange(keywords, limit, offset)
            if (res) {
                commit(types.REQUEST_GET_ACTIVE_ROUTE_RANGE_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_ACTIVE_ROUTE_RANGE_ERROR, error.message)
        }
    },
    async getArchived ({ commit }) {
      try {
          let res = await Routes.getArchived()
          if (res) {
              commit(types.REQUEST_GET_ALL_ARCHIVED_ROUTES_SUCCESS, res.data)
          }
      }catch(e)  {
          commit(types.REQUEST_GET_ALL_ARCHIVED_ROUTES_ERROR, e.message)
      }
    },
    async getArchivedRange ({ commit }, rangeRequest) {
        const keywords = rangeRequest.keywords
        const limit = rangeRequest.limit
        const offset = rangeRequest.offset
        try {
            let res = await Routes.getArchivedRange(keywords, limit, offset)
            if (res) {
                commit(types.REQUEST_GET_ARCHIVED_ROUTE_RANGE_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_ARCHIVED_ROUTE_RANGE_ERROR, error.message)
        }
    },

    async getActiveCount ({ commit }) {
        const res = await Routes.getActiveCount()
        commit(types.REQUEST_GET_ACTIVE_ROUTE_COUNT, res.data)
    },
    async getArchivedCount ({ commit }) {
        const res = await Routes.getArchivedCount()
        commit(types.REQUEST_GET_ARCHIVED_ROUTE_COUNT, res.data)
    },
    async getById ({ commit }, id) {
        try {
            let res = await Routes.getById(id)
            setTagStrings(res.data)
            if (res) {
                commit(types.REQUEST_SET_SELECTED_ROUTE_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_ROUTE_BY_ID_ERROR, error.message)
        }
    },
    async selectRoute ({ commit }, route) {
        try {
            let nonCompletedTasks = route.jobTasks.filter(tasks => { return tasks.status.toLowerCase() !== 'complete'})
            setTagStrings(route)
            await commit(types.REQUEST_SET_SELECTED_ROUTE_SUCCESS, route)
            await commit(types.REQUEST_SET_SELECTED_ROUTE_INCOMPLETE_TASKS, nonCompletedTasks)
        }  catch (error) {
            commit(types.REQUEST_SET_SELECTED_ROUTE_ERROR, error.message)
        }
    },
    async delete ({ commit, dispatch }, id) {
        try {
            let res = await Routes.delete(id)
            if (res) {
                commit(types.REQUEST_DELETE_ROUTE_SUCCESS, res.data)
                dispatch('getArchived', {})
            }
        } catch (error) {
            commit(types.REQUEST_DELETE_ROUTE_ERROR, error.message)
        }
    },
    async create ({ commit }, routeToCreate ) {
        try {
            let res = await Routes.create(routeToCreate)
            if (res) {
                commit(types.REQUEST_CREATE_ROUTE_SUCCESS, res.data)
                return res.data.id
            }
        } catch (error) {
            commit(types.REQUEST_CREATE_ROUTE_ERROR, error.message)
        }
    },
    async update ({ commit, dispatch }, routeToUpdate) {
        try {
            let res = await Routes.update(routeToUpdate)
            if (res) {
                commit(types.REQUEST_UPDATE_ROUTE_SUCCESS, res.data)
                dispatch('getIsolatedRoute', routeToUpdate.id)
                dispatch('getAll', {})
            }
        } catch (error) {
            commit(types.REQUEST_UPDATE_ROUTE_ERROR, error.message)
        }
    },
    async archive ({ commit, dispatch }, id) {
        try {
            let res = await Routes.archive(id)
            if (res) {
                commit(types.REQUEST_ARCHIVE_ROUTE_SUCCESS, res.data)
                dispatch('getAll')
            }
        } catch (error) {
            commit(types.REQUEST_ARCHIVE_ROUTE_ERROR, error.message)
        }
    },

    async complete ({ commit, dispatch }, id) {
        try {
            let res = await Routes.complete(id)
            if (res) {
                commit(types.REQUEST_COMPLETE_ROUTE_SUCCESS, res.data)
                dispatch('getAll')
            }
        } catch (error) {
            commit(types.REQUEST_COMPLETE_ROUTE_ERROR, error.message)
        }
    },
    async addUserToRoute ({ commit }, userRoute ) {
        try {
            let res = await Routes.addUsersToRoute(userRoute.userId, userRoute.routeId)
            if (res) {
                commit(types.REQUEST_ADD_USERS_TO_TASK_SUCCESS, res.data)
            }
        } catch (err) {
            commit(types.REQUEST_ADD_USERS_TO_TASK_ERROR, err.message)
        }
    },
    async removeUserFromRoute ({ commit, dispatch }, userRoute) {
        try {
            let res = await Routes.removeUsersFromRoute(userRoute.userId, userRoute.routeId)
            if (res) {
                commit(types.REQUEST_REMOVE_USERS_TO_TASK_SUCCESS, res.data)
                dispatch('getById', userRoute.routeId)
                dispatch('getAll')
            }
        } catch (err) {
            commit(types.REQUEST_REMOVE_USERS_TO_TASK_ERROR, err.message)
        }
    },
    async restore ({ commit }, id) {
        try {
            let res = await Routes.restore(id)
            if (res) {
                commit(types.REQUEST_RESTORE_ROUTE_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_RESTORE_ROUTE_ERROR, error.message)
        }
    },
    async assignTasksToRoute ({ commit, dispatch }, routeAndTaskIds ) {
        try {
            let res = await Routes.assignTasks(routeAndTaskIds.routeId, routeAndTaskIds.taskIds)
            if (res) {
                commit(types.REQUEST_ADD_TASKS_TO_ROUTE_SUCCESS)
                dispatch('jobTasks/getMapTaskLocations', {}, { root: true })
                dispatch('getAll')
            }
        } catch (err) {
            commit(types.REQUEST_ADD_TASKS_TO_ROUTE_ERROR, err.message)
        }
    },
    async clearTasksFromRoute ({ commit, dispatch }, routeId ) {
        try {
            let res = await Routes.assignTasks(routeId)
            if (res) {
                commit(types.REQUEST_CLEAR_TASKS_FROM_ROUTE_SUCCESS)
                dispatch('jobTasks/getMapTaskLocations', {}, { root: true })
                dispatch('getAll')
            }
        } catch (err) {
            commit(types.REQUEST_CLEAR_TASKS_FROM_ROUTE_ERROR, err.message)
        }
    },
    async clearSelectedRoute({ commit }) {
        commit(types.CLEAR_SELECTED)
        commit(types.CLEAR_LOCATIONS)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
